import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeBarComponent } from './home-bar/home-bar.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSliderModule } from '@angular/material/slider';
import { MatDividerModule } from '@angular/material/divider';
import { WidgetDirective } from './directiva/directive-widget.directive';
import { BasemapGalleryComponent } from './basemap-gallery/basemap-gallery.component';
import { TitleBarComponent } from './title-bar/title-bar.component';
import { LayersListComponent } from './layers-list/layers-list.component';
import { SearchComponent } from './search/search.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { SelectComponent } from './select/select.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MeasurementComponent } from './measurement/measurement.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { AddLayerComponent } from './add-layer/add-layer.component';
import { OverviewMapComponent } from './overview-map/overview-map.component';
import { PrintComponent } from './print/print.component';

@NgModule({
  declarations: [
    HomeBarComponent,
    WidgetDirective,
    BasemapGalleryComponent,
    TitleBarComponent,
    LayersListComponent,
    SearchComponent,
    SelectComponent,
    MeasurementComponent,
    AddLayerComponent,
    OverviewMapComponent,
    PrintComponent,
  ],
  imports: [
    CommonModule,
    MatBottomSheetModule,
    MatIconModule,
    MatButtonModule,
    MatSliderModule,
    MatDividerModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    DragDropModule,
    MatProgressBarModule,
    MatCheckboxModule,
    MatListModule,
    MatMenuModule,
    MatExpansionModule
  ],
  exports: [
    HomeBarComponent
  ]
})
export class WidgetsModule { }
